const defaultOgDescription =
  `The Studio Collective is a community of musicians and visual artists based in San Francisco`;

const defaultOgImage = 'https://res.cloudinary.com/studiocollective/image/upload/v1650138845/Studio%20Collective/Studio%20Pictures/IMG_5081_sxfz0o.jpg';

module.exports = {defaultOgDescription, defaultOgImage};
